import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SvgIconComponent } from '@woolworthsnz/styleguide';
import { NgClass, NgIf } from '@angular/common';

@Component({
	selector: 'form-flexible-selection-tile',
	template: `
		<div>
			<ng-content select="[badge]"></ng-content>
			<input
				[id]="inputId"
				[name]="formControlName"
				type="radio"
				(change)="onChange()"
				(blur)="onTouched($event)"
				[checked]="checked"
				[disabled]="isDisabled"
			/>

			<label [for]="inputId" [ngClass]="{ tick: successIcon }">
				<div>
					<h2>{{ label }}</h2>
					<p *ngIf="description">{{ description }}</p>
				</div>

				<cdx-svg-icon *ngIf="hasChevron" name="chevron-right" fill="gray" size="small" end> </cdx-svg-icon>
				<ng-content select="[details]"></ng-content>
			</label>
		</div>
	`,
	styleUrls: ['./flexible-selection-tile.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			// eslint-disable-next-line @typescript-eslint/no-use-before-define
			useExisting: forwardRef(() => FlexibleSelectionTileComponent),
			multi: true,
		},
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgClass, NgIf, SvgIconComponent],
})
export class FlexibleSelectionTileComponent implements ControlValueAccessor {
	@Input() label: string;
	@Input() description: string;
	@Input() i18n: string;
	@Input() inputValue: string;
	@Input() inputId: string;
	@Input() formControlName: string;
	@Input() iconName: string;
	@Input() successIcon: boolean;
	@Input() isDisabled = false;
	@Input() hasChevron = false;

	checked: boolean;

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	propagateChange: any = () => {};
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	propagateTouched: any = () => {};

	onChange(): void {
		if (!this.isDisabled) {
			this.propagateChange(this.inputValue);
		}
	}

	onTouched(v: any): void {
		if (!this.isDisabled) {
			this.propagateTouched(v);
		}
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.propagateTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}

	writeValue(val: any): void {
		if (val === this.inputValue) {
			this.checked = true;
		} else {
			this.checked = false;
		}
	}
}
